import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, MapPin, Phone, Instagram, Linkedin, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A0A09] border-t border-[#F7F5F0]/10 mt-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-baseline">
              <span className="font-grotesk text-[#F7F5F0] font-black tracking-tighter text-3xl">
                BLACPAC
              </span>
              <span className="ml-1 inline-block h-3 w-3 rounded-[3px] bg-[#E85D2F]" />
            </Link>
            <p className="mt-4 font-grotesk text-[11px] tracking-[0.22em] text-[#F7F5F0]/50 uppercase">
              Packaging the Future · A BlacVerse Group Company
            </p>
            <p className="mt-8 text-[#F7F5F0]/65 leading-relaxed max-w-md text-base">
              Africa&rsquo;s leading compostable food packaging company.
              Sustainable. Practical. Affordable. Scalable. Made for African
              food. Made for the future.
            </p>

            <Link
              to="/contact"
              data-testid="footer-cta-quote"
              className="mt-10 inline-flex items-center gap-3 rounded-full bg-[#E85D2F] text-[#0A0A09] px-7 py-4 font-medium tracking-wide hover:bg-[#F47A4A] transition-colors group"
            >
              Build your supply with BlacPac
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#E85D2F] mb-5 font-semibold">
              Explore
            </p>
            <ul className="space-y-3 text-[#F7F5F0]/70">
              <li><Link to="/about" className="hover:text-[#E85D2F] transition-colors">About BlacPac</Link></li>
              <li><Link to="/products" className="hover:text-[#E85D2F] transition-colors">Products</Link></li>
              <li><Link to="/private-label" className="hover:text-[#E85D2F] transition-colors">Private Label</Link></li>
              <li><Link to="/wholesale" className="hover:text-[#E85D2F] transition-colors">Wholesale</Link></li>
              <li><Link to="/sustainability" className="hover:text-[#E85D2F] transition-colors">Sustainability</Link></li>
              <li><Link to="/contact" className="hover:text-[#E85D2F] transition-colors">Request a Quote</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#E85D2F] mb-5 font-semibold">
              Contact
            </p>
            <ul className="space-y-4 text-[#F7F5F0]/70">
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-1 text-[#E85D2F] shrink-0" />
                <a
                  href="mailto:support@blacpac.shop"
                  className="hover:text-[#E85D2F] transition-colors"
                  data-testid="footer-email"
                >
                  support@blacpac.shop
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 mt-1 text-[#E85D2F] shrink-0" />
                <span>+233 24 123 4567</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-1 text-[#E85D2F] shrink-0" />
                <span>Accra, Ghana</span>
              </li>
            </ul>
            <div className="mt-6 flex items-center gap-3">
              <a href="#" aria-label="Instagram" className="h-9 w-9 rounded-full border border-[#F7F5F0]/15 flex items-center justify-center text-[#F7F5F0]/60 hover:text-[#E85D2F] hover:border-[#E85D2F]/50 transition-colors">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="#" aria-label="LinkedIn" className="h-9 w-9 rounded-full border border-[#F7F5F0]/15 flex items-center justify-center text-[#F7F5F0]/60 hover:text-[#E85D2F] hover:border-[#E85D2F]/50 transition-colors">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="#" aria-label="Facebook" className="h-9 w-9 rounded-full border border-[#F7F5F0]/15 flex items-center justify-center text-[#F7F5F0]/60 hover:text-[#E85D2F] hover:border-[#E85D2F]/50 transition-colors">
                <Facebook className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="divider-line mt-16 mb-8" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 text-xs text-[#F7F5F0]/40 tracking-wide">
          <p>© {new Date().getFullYear()} BlacPac. A BlacVerse Group Company. All rights reserved.</p>
          <p className="font-grotesk uppercase tracking-[0.2em] text-[#E85D2F]/80">
            Packaging the Future.
          </p>
        </div>
      </div>
    </footer>
  );
}
